import { render } from "./booking-checkout.vue?vue&type=template&id=61bcb51a"
import script from "./booking-checkout.vue?vue&type=script&lang=js"
export * from "./booking-checkout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__